import { ActionBalanceActionComponent, ActionTypeCode, AdjustedProductType, ContributionType, DebtType, DepositorType, DepositType, DepositTypeCode, Gender, IdentificationType, IndexationMethod, InterestType, LinkageType, LiquidityBalanceComponent, LiquidityLayerScopeCode, LiquidityMatchedDepositCap, LiquidityPeriodBalanceType, MaritalStatus, PathTypeCode, PayerIdType, PaymentFrequency, PaymentMethod, PolicyOrAccount, PolicyStatus, PolicyTypeCategory, ProductType, RepaymentFrequency, RepaymentType, RepresentativeType, TransferRequestType } from "../interfaces/DTO/mislaka_xml_models";
import { AllocationType, BenefitType, DesignatedBondEligibility, ExternalCoverage, InsuranceCoverageType, IsBenefitApplicable, ManagementFeeDeterminedByActualExpenses, ManagementFeePathFeatures, MortgageInsurance, PensionFeeExpenseType, PensionFundType, PensionMembershipStatus, PensionPlanType, PensionRegulationType, PolicyEmploymentStatus, SurvivorsWaiverType, Tikun190Option, YieldGuaranteeType } from "../interfaces/DTO/mislaka_xml_pension_models";
import { UserTaskOrigin, UserTaskPriority, UserTaskStatus, UserTaskSystemStatus, UserTaskType } from "../interfaces/DTO/userTask/UserTask";
import { formatPensionNameExtended } from "./pensionEnumFormatter";

let cachedProductTypeMap: Record<number, string> | null = null;

export const getProductTypeMap = (): Record<number, string> => {
  if (!cachedProductTypeMap) {
    cachedProductTypeMap = {
      [ProductType.LIFE_INSURANCE_SAVINGS]: "ביטוח מנהלים",
      [ProductType.PENSION_FUND]: "קרן פנסיה",
      [ProductType.PROVIDENT_FUND]: "קופת גמל",
      [ProductType.EDUCATION_FUND]: "קרן השתלמות",
      [ProductType.PURE_SAVINGS_POLICY]: "פוליסת חיסכון טהור",
      [ProductType.PURE_RISK_POLICY]: 'פוליסת סיכון טהור',
      [ProductType.MORTGAGE_LIFE_INSURANCE]: "ביטוח חיים משכנתא",
      [ProductType.COLLECTIVE_RISK_POLICY]: "סיכון טהור קולקטיב",
      [ProductType.INVESTMENT_PROVIDENT_FUND]: "קופת גמל להשקעה",
      [ProductType.CHILD_SAVINGS]: "חיסכון לכל ילד",
    };
  }
  return cachedProductTypeMap;
};

export const formatProductType = (productType: ProductType): string => {
  const map = getProductTypeMap();
  return map[productType] ?? "";
};
let cachedAdjustedProductTypeMap: Record<number, string>;
export const getAdjustedProductTypeMap = (): Record<number, string> => {
  if (!cachedAdjustedProductTypeMap) {
    cachedAdjustedProductTypeMap = {
      [AdjustedProductType.LIFE_INSURANCE_SAVINGS]: "ביטוח מנהלים",
      [AdjustedProductType.PENSION_FUND]: "קרן פנסיה",
      [AdjustedProductType.PROVIDENT_FUND]: "קופת גמל",
      [AdjustedProductType.EDUCATION_FUND]: "קרן השתלמות",
      [AdjustedProductType.PURE_SAVINGS_POLICY]: "פוליסת חיסכון טהור",
      [AdjustedProductType.PURE_RISK_POLICY]: "פוליסת סיכון טהור",
      [AdjustedProductType.MORTGAGE_LIFE_INSURANCE]: "ביטוח חיים משכנתא",
      [AdjustedProductType.COLLECTIVE_RISK_POLICY]: "סיכון טהור קולקטיב",
      [AdjustedProductType.INVESTMENT_PROVIDENT_FUND]: "קופת גמל להשקעה",
      [AdjustedProductType.CHILD_SAVINGS]: "חיסכון לכל ילד",
     
      [AdjustedProductType.ACTIVE_MANAGERS_INSURANCE]: "ביטוח מנהלים",
      [AdjustedProductType.INACTIVE_MANAGERS_INSURANCE]:  "ביטוח מנהלים",
      [AdjustedProductType.MANDATORY_PENSION_FUND]: "פנסיה מקיפה",
      [AdjustedProductType.SUPPLEMENTARY_PENSION_FUND]: "פנסיה משלימה",
      [AdjustedProductType.BASIC_PENSION_FUND]: "פנסיה יסוד",
      [AdjustedProductType.OLD_COMPREHENSIVE_PENSION]: "פנסיה מקיפה ותיקה",
      [AdjustedProductType.OLD_BASIC_PENSION]: "פנסיה יסוד ותיקה",
      [AdjustedProductType.CAPITAL_PROVIDENT_FUND]: "קופת גמל הונית",
      [AdjustedProductType.PENSION_PROVIDENT_FUND]: "קופת גמל פנסיונית",
      [AdjustedProductType.COMBINED_PROVIDENT_FUND]: "קופת גמל הונית ופנסיונית",
    };
  }
  return cachedAdjustedProductTypeMap;
};

export const formatAdjustedProductType = (adjustedType: AdjustedProductType): string => {
  const map = getAdjustedProductTypeMap();
  return map[adjustedType] ?? "";
};

let cachedAdjustedProductTypePluralMap: Record<number, string> | null = null;

export const getAdjustedProductTypePluralMap = (): Record<number, string> => {
  if (!cachedAdjustedProductTypePluralMap) {
    cachedAdjustedProductTypePluralMap = {
      [AdjustedProductType.LIFE_INSURANCE_SAVINGS]: "ביטוחי מנהלים",
      [AdjustedProductType.PENSION_FUND]: "קרנות פנסיה",
      [AdjustedProductType.PROVIDENT_FUND]: "קופות גמל",
      [AdjustedProductType.EDUCATION_FUND]: "קרנות השתלמות",
      [AdjustedProductType.PURE_SAVINGS_POLICY]: "פוליסות חיסכון טהור",
      [AdjustedProductType.PURE_RISK_POLICY]: "פוליסות סיכון טהור",
      [AdjustedProductType.MORTGAGE_LIFE_INSURANCE]: "ביטוחי חיים משכנתא",
      [AdjustedProductType.COLLECTIVE_RISK_POLICY]: "פוליסות סיכון טהור קולקטיב",
      [AdjustedProductType.INVESTMENT_PROVIDENT_FUND]: "קופות גמל להשקעה",
      [AdjustedProductType.CHILD_SAVINGS]: "חסכונות לכל ילד",

      [AdjustedProductType.ACTIVE_MANAGERS_INSURANCE]: "ביטוחי מנהלים",
      [AdjustedProductType.INACTIVE_MANAGERS_INSURANCE]: "ביטוחי מנהלים",
      [AdjustedProductType.MANDATORY_PENSION_FUND]: "קרנות פנסיה מקיפה",
      [AdjustedProductType.SUPPLEMENTARY_PENSION_FUND]: "קרנות פנסיה משלימה",
      [AdjustedProductType.BASIC_PENSION_FUND]: "קרנות פנסיית יסוד",
      [AdjustedProductType.OLD_COMPREHENSIVE_PENSION]: "קרנות פנסיה מקיפה ותיקות",
      [AdjustedProductType.OLD_BASIC_PENSION]: "קרנות פנסיית יסוד ותיקות",
      [AdjustedProductType.CAPITAL_PROVIDENT_FUND]: "קופות גמל הוניות",
      [AdjustedProductType.PENSION_PROVIDENT_FUND]: "קופות גמל פנסיוניות",
      [AdjustedProductType.COMBINED_PROVIDENT_FUND]: "קופות גמל הוניות ופנסיוניות",
    };
  }
  return cachedAdjustedProductTypePluralMap;
};

export const formatAdjustedProductTypePlural = (adjustedType: AdjustedProductType): string => {
  const map = getAdjustedProductTypePluralMap();
  return map[adjustedType] ?? formatAdjustedProductType(adjustedType);
};

export const castToProductType = (value: string | null | undefined): ProductType | undefined => {
      // בדיקה אם הערך ריק או null
      if (!value) {
        return undefined;
      }

      // ניסיון להמיר את המחרוזת למספר
      const parsedValue = parseInt(value, 10);
      if (isNaN(parsedValue)) {
        return undefined;
      }

      // בדיקה אם הערך קיים ב-ENUM
      if (Object.values(ProductType).includes(parsedValue)) {
        return parsedValue as ProductType;
      }

      return undefined; // ערך לא חוקי
};

export const formatProductTypeExtended = (
  productType: ProductType,
  policy: PolicyOrAccount
): string => {
  if (productType === ProductType.PENSION_FUND) {
    return `קרן פנסיה ${formatPensionNameExtended(policy)}`;
  }

  if (productType === ProductType.PURE_SAVINGS_POLICY) {
    const hasPrivatePension = policy.liquidity_details.some(
      (detail) => detail.balance_component === LiquidityBalanceComponent.PRIVATE_PENSIONS
    );

    return hasPrivatePension ? "קרן חיסכון עצמאית" : "חיסכון טהור פנסיוני";
  }

  return formatProductType(productType);
};


/**
 * ממיר ערך של PolicyStatus לטקסט מתאים.
 * @param policyStatus מספר המייצג את סטטוס הפוליסה.
 * @returns טקסט המתאר את סטטוס הפוליסה.
 */
export const formatPolicyStatus = (policyStatus: PolicyStatus): string => {
  switch (policyStatus) {
    case PolicyStatus.ACTIVE:
      return "פעיל";
    case PolicyStatus.NOT_ACTIVE:
      return "לא פעיל";
    case PolicyStatus.CANCELED:
      return "מבוטל";
    case PolicyStatus.TEMPORARY_RISK:
      return "ריסק זמני";
    case PolicyStatus.CLAIM:
      return "בתביעה";
    case PolicyStatus.DEPOSIT_BLOCKED:
      return "חסום להפקדות";
    case PolicyStatus.PERIOD_ENDED:
      return "תום תקופה";
    case PolicyStatus.AUTOMATIC_TEMPORARY_RISK:
      return "ריסק זמני אוטומטי";
    case PolicyStatus.INSURANCE_COVERAGE_MAINTAINED:
      return "שמירת כיסוי ביטוחי";
    case PolicyStatus.NOT_RELEVANT:
      return "לא רלוונטי";
    default:
      return "סטטוס לא ידוע";
  }
};
export const formatDepositorType = (code: number): string => {
  switch (code) {
    case DepositorType.EMPLOYEE:
      return "עובד";
    case DepositorType.CURRENT_EMPLOYER:
      return "מעסיק נוכחי";
    case DepositorType.PREVIOUS_EMPLOYER:
      return "מעסיק קודם";
    case DepositorType.NATIONAL_INSURANCE:
      return "ביטוח לאומי";
    case DepositorType.PARENT_DEPOSIT:
      return "הפקדת הורים";
    case DepositorType.MOVING_FUNDS:
      return "ניוד כספים";
    default:
      return "לא ידוע";
  }
};
export const formatDepositType = (type?: DepositType | null): string => {
  switch (type) {
    case DepositType.CURRENT:
      return "שוטפת";
    case DepositType.ONE_TIME:
      return "חד פעמית";
    case DepositType.FUNDS_TRANSFER:
      return "ניוד כספים";
    default:
      return "לא ידוע";
  }
};
export const formatDepositTypeCode = (code: number): string => {
  switch (code) {
    case DepositTypeCode.CAPITAL:
      return "הון";
    case DepositTypeCode.PENSION_PAYING:
      return "קצבה משלמת";
    case DepositTypeCode.PENSION_NON_PAYING:
      return "קצבה לא משלמת";
    case DepositTypeCode.CUSTOMER_CHOICE:
      return "נתון לבחירת הלקוח (רלוונטי לכספים שהופקדו עד שנת 2000)";
    case DepositTypeCode.NO_SAVINGS:
      return "הפקדות לפוליסות ללא חיסכון";
    default:
      return "לא ידוע";
  }
};

export const formatContributionType = (type: number): string => {
  switch (type) {
    case ContributionType.COMPENSATION:
      return "פיצויים ממעסיק";
    case ContributionType.EMPLOYEE_CONTRIBUTIONS:
      return "הפקדות עובד"//"תגמולים עובד";
    case ContributionType.EMPLOYER_CONTRIBUTIONS:
      return "תגמולים ממעסיק";
    case ContributionType.EMPLOYER_CONTRIBUTIONS_47:
      return "הפקדת עצמאי מוכרת למס (קוד 47)"//"תגמולים47";
    case ContributionType.DISABILITY_INSURANCE:
      return "אבדן כושר עבודה";
    case ContributionType.OTHER_EMPLOYEE:
      return "שונות עובד";
    case ContributionType.OTHER_EMPLOYER:
      return "שונות ממעסיק";
    case ContributionType.EDUCATION_EMPLOYEE:
      return "קה\"ש עובד";
    case ContributionType.EDUCATION_EMPLOYER:
      return "קה\"ש מעביד";
    case ContributionType.PRIVATE_CONTRIBUTIONS:
      return "הפקדה עצמית לחיסכון"// "תגמולים פרט";
    case ContributionType.RISK_DEATH:
      return "ריסק מוות (ללא חסכון)";
    case ContributionType.CHILD_SAVINGS:
      return "חיסכון לכל ילד";
    default:
      return "סוג הפקדה לא ידוע";
  }
};
export function formatDebtType(type: DebtType): string {
  switch (type) {
    case DebtType.SEVERANCE:
      return "חוב פיצויים";
    case DebtType.CONTRIBUTIONS:
      return "חוב תגמולים";
    case DebtType.STUDY_FUND:
      return "חוב הפקדות לקרן השתלמות";
    case DebtType.INSURANCE_PREMIUM:
      return "דמי ביטוח בפיגור";
    case DebtType.BOTH:
      return "פיצויים + תגמולים";
    case DebtType.OTHER:
      return "אחר";
    default:
      return "";
  }
}
export const formatLiquidityPeriodBalanceType = (type: LiquidityPeriodBalanceType): string => {
  switch (type) {
    case LiquidityPeriodBalanceType.CAPITAL:
      return "הון";
    case LiquidityPeriodBalanceType.PAYING_PENSION:
      return "קצבה משלמת";
    case LiquidityPeriodBalanceType.NON_PAYING_PENSION:
      return "קצבה לא משלמת";
    case LiquidityPeriodBalanceType.CUSTOMER_CHOICE:
      return "נתון לבחירת הלקוח";
    default:
      return "סוג יתרה לא ידוע";
  }
};
export const formatTransferRequestType = (type: TransferRequestType): string => {
  switch (type) {
    case TransferRequestType.MEMBER_REQUEST:
      return 'בקשת העמית (להעברה חלקית של הכספים)';
    case TransferRequestType.GARNISHMENT:
      return 'עיקול בקופה המעבירה (בהעברה חלקית)';
    case TransferRequestType.COLLATERAL:
      return 'שעבוד בקופה המעבירה (בהעברה חלקית)';
    case TransferRequestType.EMPLOYER_DEBT_REPAYMENT:
      return 'פרעון חוב מעסיק';
    case TransferRequestType.OTHER:
      return 'אחר';
    case TransferRequestType.NOT_RELEVANT:
      return 'העברה מלאה';
    default:
      return 'לא ידוע'; // ✅ ערך ברירת מחדל למקרה של שגיאה
  }
};
export const formatLiquidityMatchedDepositCap = (cap: LiquidityMatchedDepositCap): string => {
  switch (cap) {
    case LiquidityMatchedDepositCap.UP_TO_CAP:
      return "עד התקרה";
    case LiquidityMatchedDepositCap.ABOVE_CAP:
      return "מעל התקרה";
    case LiquidityMatchedDepositCap.NA:
      return "לא זמין";
    default:
      return "תקרת נזילות לא ידועה";
  }
};


export const formatPolicyTypeCategory = (type: PolicyTypeCategory): string => {
  switch (type) {
    case PolicyTypeCategory.CLASSIC:
      return "קלאסי";
    case PolicyTypeCategory.PREFERRED:
      return "עדיף";
    case PolicyTypeCategory.POST_2004:
      return "פוליסות משנת 2004 ואילך";
    case PolicyTypeCategory.RISK_OR_DISABILITY:
      return "ריסק ואו אכ\"ע";
    default:
      return "סוג פוליסה לא ידוע";
  }
};

export const formatActionTypeCode = (code: ActionTypeCode): string => {
  switch (code) {
    case ActionTypeCode.WITHDRAWAL:
      return "משיכה";
    case ActionTypeCode.TRANSFER:
      return "ניוד";
    case ActionTypeCode.CORRECTION:
      return "תיקון";
    default:
      return "קוד פעולה לא ידוע";
  }
};
export const formatPensionFundType = (fundType: PensionFundType): string => {
  switch (fundType) {
    case PensionFundType.PAYING:
      return "משלמת";
    case PensionFundType.NON_PAYING:
      return "לא משלמת";
    case PensionFundType.TRAINING_FUND:
      return "קרן השתלמות";
    default:
      return "סוג קופה לא ידוע";
  }
};

export const formatInterestType = (type: InterestType): string => {
  switch (type) {
    case InterestType.FIXED:
      return "ריבית קבועה";
    case InterestType.VARIABLE:
      return "ריבית משתנה";
    default:
       return "-";
  }
};
// formatLinkageType
export const formatLinkageType = (type: LinkageType): string => {
  switch (type) {
    case LinkageType.NONE:
      return "ללא הצמדה למדד";
    case LinkageType.MONTHLY_INDEX:
      return "מדד חודשי";
    case LinkageType.SEMI_ANNUAL_INDEX:
      return "מדד חצי שנתי";
    case LinkageType.OTHER:
      return "אחר";
    default:
      return "-";
  }
};
export const formatYesNo = (
  value: ManagementFeeDeterminedByActualExpenses
): string => {
  switch (value) {
    case ManagementFeeDeterminedByActualExpenses.YES:
      return "כן";
    case ManagementFeeDeterminedByActualExpenses.NO:
      return "לא";
    default:
      return "לא ידוע";
  }
};
export const formatBenefitType = (type: BenefitType): string => {
  switch (type) {
    case BenefitType.NO_CONDITIONS:
      return "אין התניות";
    case BenefitType.TIME_LIMITED:
      return "מוגבלת בזמן";
    case BenefitType.DEPOSIT_AMOUNT_DEPENDENT:
      return "מותנת בגובה ההפקדה";
    case BenefitType.SAVINGS_AMOUNT_DEPENDENT:
      return "מותנת בגובה הצבירה";
    case BenefitType.EMPLOYER_OR_UNION_DEPENDENT:
      return "מותנת בשיוך למעסיק או לארגון עובדים";
    case BenefitType.OTHER_CONDITIONS:
      return "מותנת בתנאים נוספים";
    default:
      return "-";
  }
};
export const formatAllocationType = (type: AllocationType): string => {
  switch (type) {
    case AllocationType.NOT_RELEVANT:
      return "לא רלוונטי";
    case AllocationType.COMPENSATION:
      return "פיצויים";
    case AllocationType.EMPLOYEE_PENSION:
      return "תגמולים עובד";
    case AllocationType.EMPLOYER_PENSION:
      return "תגמולים מעביד";
    default:
      return "סוג הפרשה לא ידוע";
  }
};
export const formatPensionFeeExpenseType = (type: PensionFeeExpenseType): string => {
  switch (type) {
    case PensionFeeExpenseType.NOT_RELEVANT:
      return "לא רלוונטי";
    case PensionFeeExpenseType.FROM_SAVINGS:
      return "דמי ניהול מצבירה";
    case PensionFeeExpenseType.FROM_DEPOSITS:
      return "דמי ניהול מהפקדה";
    default:
      return "סוג הוצאה לא ידוע";
  }
};
export const formatIsBenefitApplicable = (type: IsBenefitApplicable): string => {
  switch (type) {
    case IsBenefitApplicable.YES:
      return "כן";
    case IsBenefitApplicable.NO:
      return "לא";
    default:
      return "לא ידוע";
  }
};
export const formatGender = (gender: Gender): string => {
  switch (gender) {
    case Gender.MALE:
      return "זכר";
    case Gender.FEMALE:
      return "נקבה";
    case Gender.UNKNOWN:
      return "לא ידוע";
    default:
      return "לא ידוע";
  }
};

export const formatMaritalStatus = (status: MaritalStatus): string => {
  switch (status) {
    case MaritalStatus.NOT_RELEVANT:
      return "לא רלוונטי";
    case MaritalStatus.SINGLE:
      return "רווק/ה";
    case MaritalStatus.MARRIED:
      return "נשוי/נשואה";
    case MaritalStatus.DIVORCED:
      return "גרוש/ה";
    case MaritalStatus.WIDOWED:
      return "אלמן/אלמנה";
    case MaritalStatus.UNKNOWN:
      return "לא ידוע";
    case MaritalStatus.COHABITATING:
      return "ידועים בציבור";
    default:
      return "סטטוס לא ידוע";
  }
};


export const formatManagementFeePathFeatures = (
  value: ManagementFeePathFeatures
): string => {
  switch (value) {
    case ManagementFeePathFeatures.NOT_RELEVANT:
      return "לא רלוונטי";
    case ManagementFeePathFeatures.FIXED_RATE:
      return "שיעור קבוע";
    case ManagementFeePathFeatures.VARIABLE_BY_DEPOSIT_TENURE:
      return "משתנה לפי ותק הפקדות";
    case ManagementFeePathFeatures.VARIABLE_BY_DEPOSIT_AND_SAVINGS_TENURE:
      return "משתנה לפי ותק הפקדות ו/או צבירה";
    case ManagementFeePathFeatures.LOWER_OF_FIXED_OR_AMOUNT:
      return "שיעור קבוע/סכום לפי הנמוך";
    case ManagementFeePathFeatures.VARIABLE_BY_SAVINGS:
      return "משתנה לפי צבירה";
    case ManagementFeePathFeatures.SAVINGS_TILL_2004:
      return "משתנים לפוליסות משתתפות עד 2004";
    case ManagementFeePathFeatures.SAVINGS_BY_AMOUNT:
      return "משתנים לפי צבירה";
    case ManagementFeePathFeatures.SAVINGS_BY_AGE:
      return "משתנים לפי גיל";
    case ManagementFeePathFeatures.SAVINGS_BY_TENURE:
      return "משתנים לפי ותק הפקדות";
    case ManagementFeePathFeatures.OTHER_CONDITIONS:
      return "מותנה בתנאים נוספים";
    default:
      return "לא ידוע";
  }
};

// הפונקציות הנוספות ייכתבו בסגנון דומה עבור שאר ה-Enums

export const formatLoanToPolicyRatio = (value?: number): string => {
  switch (value) {
    case 1:
      return "פוליסה ספציפית";
    case 2:
      return "כלל הפוליסות";
    default:
      return "-";
  }
};
// formatRepaymentFrequency
export const formatRepaymentFrequency = (frequency: RepaymentFrequency): string => {
  switch (frequency) {
    case RepaymentFrequency.MONTHLY:
      return "חודשי";
    case RepaymentFrequency.QUARTERLY:
      return "רבעוני";
    case RepaymentFrequency.SEMI_ANNUAL:
      return "חצי שנתי";
    case RepaymentFrequency.ANNUAL:
      return "שנתי";
    case RepaymentFrequency.OTHER:
      return "אחר";
    default:
      return "תדירות החזר לא ידועה";
  }
};

// formatRepaymentType
export const formatRepaymentType = (type: RepaymentType): string => {
  switch (type) {
    case RepaymentType.SPITZER:
      return "החזרים שווים שפיצר";
    case RepaymentType.CURRENT_INTEREST:
      return "ריבית שוטפת";
    default:
      return "-";
  }
};


export const formatActionBalanceActionComponent = (
  component: ActionBalanceActionComponent
): string => {
  switch (component) {
    case ActionBalanceActionComponent.COMPENSATION:
      return "פיצויים ממעסיק";
    case ActionBalanceActionComponent.EMPLOYEE_PENSIONS:
      return "הפקדות עובד"//"תגמולים עובד";
    case ActionBalanceActionComponent.EMPLOYER_PENSIONS:
      return "תגמולים ממעסיק";
    case ActionBalanceActionComponent.PENSIONS_47:
      return "הפקדת עצמאי מוכרת למס (קוד 47)"//"תגמולים47";
    case ActionBalanceActionComponent.MISC_EMPLOYEE:
      return "שונות עובד";
    case ActionBalanceActionComponent.MISC_EMPLOYER:
      return "שונות ממעסיק";
    case ActionBalanceActionComponent.SAVINGS_EMPLOYEE:
      return 'קה"ש עובד';
    case ActionBalanceActionComponent.SAVINGS_EMPLOYER:
      return 'קה"ש ממעסיק';
    case ActionBalanceActionComponent.PRIVATE_PENSIONS:
      return "הפקדה עצמית לחיסכון"// "תגמולים פרט";
    case ActionBalanceActionComponent.PREMIUM_REFUND:
      return "החזר פרמיה";
    case ActionBalanceActionComponent.MANAGEMENT_FEE_REFUND:
      return "החזר דמי ניהול";
    case ActionBalanceActionComponent.OTHER:
      return "אחר";
    case ActionBalanceActionComponent.CHILD_SAVINGS:
      return "חיסכון לכל ילד";
    default:
      return "רכיב פעולה לא ידוע";
  }
};


export const formatLiquidityLayerScopeCode = (code: LiquidityLayerScopeCode): string => {
  switch (code) {
    case LiquidityLayerScopeCode.UNTIL_BUDGETARY_LAW_1997_2000:
      return "עד חוק ההסדרים (1997 2000)";
    case LiquidityLayerScopeCode.AFTER_BUDGETARY_LAW_1997_2000:
      return "לאחר חוק ההסדרים (1997 2000)";
    case LiquidityLayerScopeCode.UNTIL_31_12_2004:
      return "עד 31.12.2004";
    case LiquidityLayerScopeCode.UNTIL_31_12_2005:
      return "עד 31.12.2005";
    case LiquidityLayerScopeCode.FROM_01_01_2005_TO_31_12_2007:
      return "מ-01.01.2005 עד 31.12.2007";
    case LiquidityLayerScopeCode.FROM_01_01_2006_TO_31_12_2007:
      return "מ-01.01.2006 עד 31.12.2007";
    case LiquidityLayerScopeCode.FROM_01_01_2008:
      return "מ- 01.01.2008";
    case LiquidityLayerScopeCode.UNTIL_31_12_2002:
      return "עד 31.12.2002";
    case LiquidityLayerScopeCode.COMPENSATION:
      return "פיצויים";
    case LiquidityLayerScopeCode.MANUAL_CALCULATION_REQUIRED:
      return "נדרש חישוב ידני";
    case LiquidityLayerScopeCode.FROM_01_01_2003_TO_31_12_2005:
      return "מ-01.01.2003 ועד 31.12.2005";
    case LiquidityLayerScopeCode.FROM_01_01_2006_TO_31_12_2011:
      return "מ-01.01.2006 ועד 31.12.2011";
    case LiquidityLayerScopeCode.FROM_01_01_2012:
      return "החל מ - 01.01.2012";
    case LiquidityLayerScopeCode.NEW_ACCOUNT:
      return "חשבון חדש";
    default:
      return "קוד שכבת נזילות לא ידוע";
  }
};


export const formatLiquidityBalanceComponent = (component: LiquidityBalanceComponent): string => {
  switch (component) {
    case LiquidityBalanceComponent.COMPENSATION:
      return "פיצויים ממעסיק";
    case LiquidityBalanceComponent.EMPLOYEE_PENSIONS:
      return "הפקדות עובד"//"תגמולים עובד";
    case LiquidityBalanceComponent.EMPLOYER_PENSIONS:
      return "תגמולים ממעסיק";
    case LiquidityBalanceComponent.PENSIONS_47:
      return "הפקדת עצמאי מוכרת למס (קוד 47)"//"תגמולים47";
    case LiquidityBalanceComponent.DISABILITY_LOSS:
      return "אבדן כושר עבודה";
    case LiquidityBalanceComponent.MISC_EMPLOYEE:
      return "שונות עובד";
    case LiquidityBalanceComponent.MISC_EMPLOYER:
      return "שונות ממעסיק";
    case LiquidityBalanceComponent.SAVINGS_EMPLOYEE:
      return "קה\"ש עובד";
    case LiquidityBalanceComponent.SAVINGS_EMPLOYER:
      return "קה\"ש מעביד";
    case LiquidityBalanceComponent.PRIVATE_PENSIONS:
      return "הפקדה עצמית לחיסכון"// "תגמולים פרט";
    case LiquidityBalanceComponent.RISK_DEATH_NO_SAVINGS:
      return "ריסק מוות (ללא חסכון)";
    case LiquidityBalanceComponent.SAVINGS_FOR_CHILD:
      return "חיסכון לכל ילד";
    default:
      return "רכיב יתרה לא ידוע";
  }
};
export const formatGuaranteedConversionFactor = (value?: number): string => {
  const mapping: Record<number, string> = {
    1: "כן",
    2: "לא",
  };
  return mapping[value ?? 2] || "לא ידוע";
};

export const formatYieldImpact = (value?: number): string => {
  const mapping: Record<number, string> = {
    1: "כן",
    2: "לא",
  };
  return mapping[value ?? 2] || "לא ידוע";
};

export const formatLifeExpectancyImpact = (value?: number): string => {
  const mapping: Record<number, string> = {
    1: "כן",
    2: "לא",
  };
  return mapping[value ?? 2] || "לא ידוע";
};

export const formatSurvivorsWaiverType = (value?: number | SurvivorsWaiverType): string => {
  switch (value) {
    case SurvivorsWaiverType.NOT_EXISTS:
      return "";
    case SurvivorsWaiverType.FULL_WAIVER:
      return "ויתור מלא";
    case SurvivorsWaiverType.CHILDREN_ONLY:
      return "ויתור כיסוי ילדים";
    case SurvivorsWaiverType.SPOUSE_ONLY:
      return "ויתור כיסוי בן.ת זוג";
    default:
      return "לא ידוע";
  }
};

export const formatDevelopingDisability = (value?: number): string => {
  const mapping: Record<number, string> = {
    1: "יש",
    2: "אין",
  };
  return mapping[value ?? 2] || "לא ידוע";
};

export const formatInsuranceWaiver = (value?: number): string => {
  const mapping: Record<number, string> = {
    1: "יש",
    2: "אין",
    3: "לא רלוונטי",
  };
  return mapping[value ?? 3] || "לא ידוע";
};

export const formatInsuranceBenefit = (value?: number): string => {
  const mapping: Record<number, string> = {
    1: "כן",
    2: "לא",
    3: "לא ידוע",
  };
  return mapping[value ?? 3] || "לא ידוע";
};

export const formatPolicyEmploymentStatus = (status: PolicyEmploymentStatus): string => {
  switch (status) {
    case PolicyEmploymentStatus.EMPLOYEE:
      return "שכיר";
    case PolicyEmploymentStatus.SELF_EMPLOYED:
      return "עצמאי";
    case PolicyEmploymentStatus.CONTROLLING_OWNER:
      return "בעל שליטה";
    case PolicyEmploymentStatus.OTHER:
      return "אחר";
    case PolicyEmploymentStatus.PRIVATE:
      return "פרטי";
    case PolicyEmploymentStatus.SELF_EMPLOYED_AND_EMPLOYEE:
        return "שכיר ועצמאי";
    case PolicyEmploymentStatus.REIRED:
        return "פנסיונר";
    case PolicyEmploymentStatus.UNEMPLOYED:
        return "לא עובד.ת";
    case PolicyEmploymentStatus.KIBBUTZ_MEMBER:
        return "חבר.ת קיבוץ";
    case PolicyEmploymentStatus.STUDENT:
        return "סטודנט.ית";
    case PolicyEmploymentStatus.SOLDIER:
        return "חייל.ת";
    case PolicyEmploymentStatus.YESHIVA_STUDENT:
        return "תלמיד ישיבה";
    default:
      return "-";
  }
};

export const formatExternalCoverage = (coverage: ExternalCoverage): string => {
  return coverage === ExternalCoverage.YES ? "כן" : "לא";
};
export function formatRepresentativeType(value?: RepresentativeType | null): string {
  switch (value) {
    case RepresentativeType.AGENT:
      return "סוכן";
    case RepresentativeType.ADVISOR:
      return "יועץ";
    case RepresentativeType.GUARDIAN:
      return "אפוטרופוס";
    case RepresentativeType.OTHER:
      return "אחר";
    default:
      return "לא ידוע";
  }
}
export function formatIdentificationType(value?: IdentificationType | null): string {
  switch (value) {
    case IdentificationType.INDIVIDUAL:
      return "פרטי";
    case IdentificationType.CORPORATION:
      return "תאגיד";
    default:
      return "לא ידוע";
  }
}
export const formatPensionPlanType = (type: PensionPlanType): string => {
  switch (type) {
    case PensionPlanType.BASIC:
      return "יסוד";
    case PensionPlanType.COMPREHENSIVE:
      return "מקיפה";
    case PensionPlanType.GENERAL:
      return "כללית";
    default:
      return "";
  }
};

export const formatPensionRegulationType = (type: PensionRegulationType): string => {
  return type === PensionRegulationType.OLD_SCHEME ? "ותיקה" : "חדשה";
};

export const formatPensionMembershipStatus = (status: PensionMembershipStatus): string => {
  switch (status) {
    case PensionMembershipStatus.INSURED:
      return "מבוטח";
    case PensionMembershipStatus.NOT_INSURED:
      return "לא מבוטח";
    case PensionMembershipStatus.NOT_RELEVANT:
      return "לא רלוונטי";
    default:
      return "מעמד עמית לא ידוע";
  }
};
export const formatPayerIdType = (type?: PayerIdType): string => {
  switch (type) {
    case PayerIdType.CHP:
      return "ח.פ";
    case PayerIdType.CHZ:
      return "ח.צ";
    case PayerIdType.TEUDAT_ZEHUT:
      return "ת.ז";
    case PayerIdType.PASSPORT:
      return "דרכון";
    case PayerIdType.CORPORATION:
      return "תאגיד";
    case PayerIdType.OSEK_MORSHE:
      return "עוסק מורשה";
    case PayerIdType.EMPLOYER_CODE:
      return "מספר מעסיק אצל היצרן";
    case PayerIdType.UNKNOWN:
      return "לא ידוע";
    default:
      return "סוג מזהה לא ידוע";
  }
};
export function formatPathTypeCode(code?: number): string {
  switch (code) {
    case PathTypeCode.ACCUMULATED:
      return "מצבירה";
    case PathTypeCode.CURRENT:
      return "שוטף";
    default:
      return "לא ידוע";
  }
}
export function formatPaymentFrequency(frequency: PaymentFrequency): string {
  switch (frequency) {
    case PaymentFrequency.YEARLY:
      return "שנתי";
    case PaymentFrequency.SEMI_YEARLY:
      return "חצי-שנתי";
    case PaymentFrequency.QUARTERLY:
      return "רבעוני";
    case PaymentFrequency.MONTHLY:
      return "חודשי";
    case PaymentFrequency.ONE_TIME:
      return "חד פעמי";
    default:
      return "לא ידוע";
  }
}
export const formatPaymentMethod = (method?: PaymentMethod): string => {
  switch (method) {
    case PaymentMethod.BANK_TRANSFER:
      return "העברה בנקאית";
    case PaymentMethod.DIRECT_DEBIT:
      return "הוראת קבע";
    case PaymentMethod.CREDIT_CARD:
      return "כרטיס אשראי";
    case PaymentMethod.CASH:
      return "מזומן";
    case PaymentMethod.OTHER:
      return "אחר";
    case PaymentMethod.CHECK:
      return "המחאה";
    default:
      return "אמצעי תשלום לא ידוע";
  }
};
export const formatIndexationMethod = (method?: IndexationMethod): string => {
  switch (method) {
    case IndexationMethod.TO_SALARY:
      return "צמוד לשכר";
    case IndexationMethod.CPI:
      return "מדד מחירים לצרכן";
    case IndexationMethod.WEIGHTED_COLLECTION_INDEX:
      return "מדד גביה משוקלל";
    case IndexationMethod.HALF_YEARLY:
      return "מדד חצי-שנתי";
    case IndexationMethod.HALF_YEARLY_ADJUSTED:
      return "מדד חצי-שנתי מותאם";
    case IndexationMethod.NOT_INDEXED:
      return "לא צמוד";
    case IndexationMethod.USD:
      return "צמוד לדולר";
    case IndexationMethod.KNOWN_INDEX_FIRST:
      return "צמוד למדד ידוע בראשון לחודש";
    case IndexationMethod.KNOWN_INDEX_LAST:
      return "צמוד למדד אחרון ידוע";
    case IndexationMethod.COST_OF_LIVING_WITH_CEILING:
      return "צמוד לתוספת יוקר עם תקרה";
    case IndexationMethod.COST_OF_LIVING_NO_CEILING:
      return "צמוד לתוספת יוקר בלי תקרה";
    default:
      return "אופן הצמדה לא ידוע";
  }
};
export function formatDesignatedBondEligibility(value?: DesignatedBondEligibility): string {
  switch (value) {
    case DesignatedBondEligibility.DesignatedBondsOnly:
      return "כן, באמצעות אג\"ח מיועדות בלבד";
    case DesignatedBondEligibility.DesignatedBondsOrGuaranteedYield:
      return "כן באמצעות אג\"ח מיועדות ו/או מנגנון אפיק השקעה מובטח תשואה";
    case DesignatedBondEligibility.PolicyTermsOrFundRegulation:
      return "כן, באמצעות הבטחת תשואה מתוקף תנאי הפוליסה או תקנון קופת הגמל";
    case DesignatedBondEligibility.No:
      return "לא";
    default:
      return "";
  }
}
export const formatYieldGuaranteeType = (type: YieldGuaranteeType): string => {
  if (type === undefined || type === null) {
    return "-";
  }
  return type === YieldGuaranteeType.YES ? "כן" : "לא";
};

export const formatTikun190Option = (option: Tikun190Option): string => {
  return option === Tikun190Option.YES ? "כן" : "לא";
};

// ✅ Re-export from insightsRuleUtils for backwards compatibility
export { formatRuleType } from "./insightsRuleUtils";

export const formatInsuranceCoverageType = (type: InsuranceCoverageType): string => {
  switch (type) {
    case InsuranceCoverageType.INDIVIDUAL:
      return "אישי";
    case InsuranceCoverageType.GROUP:
      return "קבוצתי";
    case InsuranceCoverageType.BOTH:
      return "קיימים כיסויים מסוג אישי וגם מסוג קבוצתי";
    default:
      return "סוג כיסוי ביטוחי לא ידוע";
  }
};

export const formatMortgageInsurance = (type: MortgageInsurance): string => {
  return type === MortgageInsurance.YES ? "כן" : "לא";
};



export const fundsFacetFormatter = (fieldName: string): string => {
  switch (fieldName) {
    case "fund_classification":
      return "סיווג";
    case "fund_name":
      return "קרן";
    case "sub_specialization":
      return "מסלול";
    case "managing_corporation":
      return "יצרן";
    case "product_type":
      return "סוג מוצר";
    default:
      return "שדה לא מוכר";
  }
};
export function formatUserTaskStatus(status: UserTaskStatus | null | undefined): string {
  switch (status) {
    case UserTaskStatus.PENDING:
      return "ממתינה לטיפול";  
    case UserTaskStatus.IN_PROGRESS:
      return "בתהליך";
    case UserTaskStatus.COMPLETED:
      return "הושלמה";
      case UserTaskStatus.REJECTED:
        return "נדחתה";
    case UserTaskStatus.FAILED:
      return "נכשלה";
      case UserTaskStatus.IGNORED:
        return "מבוטלת";

    default:
      return "לא ידוע";
  }
}
export function formatUserTaskSystemStatus(status: UserTaskSystemStatus | null | undefined): string {
  switch (status) {
    case UserTaskSystemStatus.UNCHECKED:
      return "טרם נבדק";
    case UserTaskSystemStatus.PENDING:
      return "ממתין לנתוני מסלקה";
    case UserTaskSystemStatus.AWAITING:
      return "ממתין להשתקפות";
    case UserTaskSystemStatus.MATCH:
      return "תואם";
    case UserTaskSystemStatus.MISMATCH:
      return "אי-התאמה";
    case UserTaskSystemStatus.FAILED:
      return "שגיאה בבדיקה";
    default:
      return "לא זמין";
  }
}
export function formatUserTaskType(taskType: UserTaskType): string {
  switch (taskType) {
    case UserTaskType.TRANSFER_IN:
      return "העברה פנימה";
    case UserTaskType.TRANSFER_OUT:
      return "העברה החוצה";
    case UserTaskType.FEE_CHANGE:
      return "שינוי עמלות";
    case UserTaskType.NEW_CLIENT:
      return "לקוח חדש";
    case UserTaskType.JOIN_POLICY:
      return "הצטרפות לפוליסה";
    case UserTaskType.OTHER:
      return "אחר";
    case UserTaskType.JOIN_REJECT:
      return "דחיית הצטרפות";
    case UserTaskType.DEPOSIT_TRACKING:
      return "מעקב הפקדות";
    case UserTaskType.WITHDRAWAL:
      return "משיכות";

    case UserTaskType.LOAN_TRACKING:
      return "מעקב הלוואות";
    case UserTaskType.CONSULTING:
      return "ייעוץ פנסיוני";
    case UserTaskType.POWER_OF_ATTORNEY:
      return "ייפוי כוח";
    case UserTaskType.AGENT_UPDATE:
      return "עדכון סוכן";
    case UserTaskType.LOST_ACCOUNT_TRACKING:
      return "מעקב חשבון מנותק קשר";
    case UserTaskType.AGENT_APPOINTMENT:
      return "מינוי סוכן";
    case UserTaskType.AGENT_CANCELLATION:
      return "ביטול מינוי סוכן";
    case UserTaskType.PATH_CHANGE:
        return "שינוי מסלול";
    case UserTaskType.BENEFICIARY_UPDATE:
      return "עדכון מוטבים";
    case UserTaskType.VIEW_POWER_OF_ATTORNEY:
      return "ייפוי כוח לצפייה";
    default:
      return taskType;
  }
}
export const formatUserTaskOrigin = (origin: UserTaskOrigin): string => {
  switch (origin) {
    case UserTaskOrigin.SIMULATION:
      return "סימולציה";
    case UserTaskOrigin.MANUAL:
      return "ידני";
    case UserTaskOrigin.SYSTEM:
      return "מערכתי";
    case UserTaskOrigin.EXTERNAL:
      return "חיצוני";
    default:
      return origin;
  }
};
export const formatUserTaskPriority = (priority: UserTaskPriority): string => {
  switch (priority) {
    case UserTaskPriority.LOW:
      return "נמוכה";
    case UserTaskPriority.MEDIUM:
      return "בינונית";
    case UserTaskPriority.HIGH:
      return "גבוהה";
    case UserTaskPriority.URGENT:
      return "דחופה";
    default:
      return priority;
  }
};

